import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const PolitykaCookies = () => {
  return (
    <Layout>
      <SEOHead
        title="Polityka Cookies | naklejki-3d.com.pl"
        description="Polityka cookies naklejki-3d.com.pl – informacje o plikach cookies i sposobach zarządzania nimi."
      />
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-3xl lg:text-4xl font-bold text-foreground mb-8">Polityka Cookies</h1>

          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-sm">Ostatnia aktualizacja: 23 lutego 2026</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">1. Czym są pliki cookies?</h2>
            <p>Pliki cookies (ciasteczka) to małe pliki tekstowe zapisywane na Twoim urządzeniu podczas odwiedzania naszej strony. Służą do prawidłowego działania witryny oraz zbierania informacji o sposobie jej użytkowania.</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">2. Jakich cookies używamy?</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Niezbędne</strong> – wymagane do prawidłowego działania strony (np. zapamiętanie zgody na cookies)</li>
              <li><strong>Analityczne</strong> – pomagają nam zrozumieć, jak użytkownicy korzystają ze strony (np. Google Analytics)</li>
              <li><strong>Funkcjonalne</strong> – zapamiętują Twoje preferencje (np. język, region)</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mt-8">3. Jak zarządzać cookies?</h2>
            <p>Możesz zarządzać plikami cookies w ustawieniach swojej przeglądarki. Możesz je zablokować lub usunąć, jednak może to wpłynąć na funkcjonowanie strony.</p>
            <p>Popularne przeglądarki umożliwiają:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Blokowanie wszystkich cookies</li>
              <li>Akceptowanie tylko cookies z odwiedzanej strony</li>
              <li>Usuwanie cookies po zamknięciu przeglądarki</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mt-8">4. Okres przechowywania</h2>
            <p>Cookies sesyjne są usuwane po zamknięciu przeglądarki. Cookies trwałe przechowywane są przez okres wskazany w parametrach pliku cookie, jednak nie dłużej niż 12 miesięcy.</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">5. Kontakt</h2>
            <p>Pytania dotyczące polityki cookies prosimy kierować na adres: biuro@projekt-art.pl.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PolitykaCookies;
